import React, { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { ArrowForward, CloseIcon } from '@yme/assets/icons';
import { Alert, AlertType } from '@yme/atoms/alert';
import { Button, CONTAINED_VARIANT, ICON_ONLY, SIZE_36, SIZE_44, TEXT_VARIANT, TRAILING_ICON, } from '@yme/atoms/button';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { getCart, getCartEntries } from '@yme/common/redux/cart/selectors';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { getCurrencyRate, getPDPLinks } from '@yme/selectors/common';
import { getRootLang } from '@yme/selectors/index';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { getPdpLinkByCategory } from '@yme/utils/product';
import { EmptyCart } from './EmptyCart';
import { OrderSummaryPrice } from './OrderSummaryPrice';
import { PopupOrderSummary } from './PopupOrderSummary';
import { HeadingLevel2Styled, OrderSummaryPriceWrapper, ShoppingCartPopupStyled } from './styled';
export const ShoppingCartPopup = ({ handleClosePopup, cartLink, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isItemDeleted, setIsItemDeleted] = useState(false);
    const { t } = useTranslation();
    const notificationTimeout = useRef(null);
    const currencyRate = useSelector(getCurrencyRate);
    const rootLanguage = useSelector(getRootLang);
    const cartEntries = useSelector(getCartEntries);
    const pdpLinks = useSelector(getPDPLinks);
    const cart = useSelector(getCart);
    const handleRemoveProduct = useCallback(() => {
        setIsItemDeleted(true);
        if (notificationTimeout.current) {
            clearTimeout(notificationTimeout.current);
        }
        notificationTimeout.current = setTimeout(() => {
            setIsItemDeleted(false);
        }, 2500);
    }, []);
    const handleProceedButtonClick = useCallback(() => {
        if (cart.data && currencyRate) {
            setDigitalData(DigitalDataMutation.SHOPPING_CART_POPUP_PROCEED_CLICK, {
                cart: cart.data,
                getPdpLinkByCategory: getPdpLinkByCategory.bind(null, pdpLinks),
            }, currencyRate);
        }
    }, [cart.data, currencyRate, pdpLinks]);
    return (React.createElement(ShoppingCartPopupStyled, null,
        React.createElement(SpinnerLoader, { isLoading: isLoading },
            React.createElement(FlexWrapper, { isFullWidth: true, justifyContent: "space-between", mb: "24px" },
                React.createElement(HeadingLevel2Styled, null, t('shoppingCart_yourCart_header')),
                React.createElement(Button, { onClick: handleClosePopup, size: SIZE_36, hasIconButton: ICON_ONLY, buttonVariant: TEXT_VARIANT, iconComponent: CloseIcon, width: "auto" })),
            isItemDeleted && (React.createElement(FlexWrapper, { isFullWidth: true, mb: "24px" },
                React.createElement(Alert, { type: AlertType.MESSAGE, message: t('shoppingCart_itemRemoval_label'), isFullWidth: true, hideExtraContent: true }))),
            Boolean(cartEntries.length) ? (React.createElement(React.Fragment, null,
                React.createElement(PopupOrderSummary, { cartEntries: cartEntries, rootLanguage: rootLanguage, setIsLoading: setIsLoading, handleRemoveProduct: handleRemoveProduct }),
                React.createElement(OrderSummaryPriceWrapper, null,
                    React.createElement(OrderSummaryPrice, { rootLanguage: rootLanguage })),
                React.createElement(FlexWrapper, { mt: "24px" },
                    React.createElement(ButtonLinkWrapper, { buttonLink: cartLink },
                        React.createElement(Button, { label: t('shoppingCart_proceedToShoppingCart_button'), buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, size: SIZE_44, onClick: handleProceedButtonClick }))))) : (React.createElement(EmptyCart, null)))));
};
